import { styled } from '@mui/material';
import Navbar from '../../components/Navbar';
import ProductsSection from '../../sections/Products';
import theme from '../../styles';

const Products = () => {
  return (
    <MainContainer>
      <Navbar position='sticky' customtextcolor={theme.color.primary} />
      <ProductsSection />
    </MainContainer>
  );
};

const MainContainer = styled('div')(() => ({}));

export default Products;
